import React, { Fragment } from 'react';

export default function InformationAboutClosedArena() {
	return (
		<Fragment>
			{/*<br />*/}
			{/*tenha prioridade na inscrição.*/}
			{/*<br />*/}
			{/*<br />*/}
			<span style={{ fontSize: '16px', color: '#CCCCCC' }}>Tenha prioridade na inscrição cadastrando-se na</span>
			<br />
			<strong
				style={{
					fontSize: '48px',
					lineHeight: '48px',
					textTransform: 'uppercase',
					color: 'white',
					fontFamily: 'Manrope',
				}}
			>
				Lista de espera
			</strong>
			<br />
			<span style={{ color: '#CCCCCC' }}>As vagas são limitadas!</span>
			<br />
			<br />
			<br />
			<span style={{ fontSize: '14px', color: '#E6E6E6' }}>Próxima turma presencial:</span>
			<br />
			<div
				style={{
					width: 'fit-content',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: '14px',
					padding: '14px',
					border: '1px solid #999999',
					borderRadius: '8px',
					backgroundColor: '#262626',
				}}
			>
				<strong style={{ fontSize: '20px' }}>07-08</strong> de Junho
			</div>
		</Fragment>
	);
}
